import { Game } from '@repo/types'
import { ToggleSwitch } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import { updateGameSetting } from '@/store/game/updateGameDocument'

import { SettingsRow } from '../SettingsRow'

const SETTING_NAME = 'Previous Songs'
const SETTING_ID = 'jumbotron.enablePreviousSongs' as const

export const EnableJumbotronPreviousSongs = observer(
  function EnableJumbotronPreviousSongs(): React.ReactElement | null {
    const { gameData, gameId, tracker } = useGameContext()

    if (gameData.type !== 'music') return null

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target

      const update: Pick<Game, typeof SETTING_ID> = {
        [SETTING_ID]: checked
      }

      void updateGameSetting(gameId, update)
      tracker.changeToggle(`Jumbotron ${SETTING_NAME}`, checked)
    }
    return (
      <SettingsRow description='Show the last three played songs on screen.' heading={SETTING_NAME}>
        <ToggleSwitch
          id={SETTING_ID}
          isChecked={gameData.jumbotron.enablePreviousSongs}
          onChange={handleChange}
        />
      </SettingsRow>
    )
  }
)
